import { useRouter } from 'next/router';
import {
  useBottomSheet,
  usePhoneBillDialog,
  useProfileCardModal,
} from '@/hooks/global-tools';
import { useEffect } from 'react';
import { cleanUpQuery, getOrganizationUrl } from '@/utils/urls';
import { FullViewPortHeightIframeWithLoading } from '@/components/IframeWithLoading';

export const ProfileCardQueryKey = 'g_profile';
export const OrganizationSheetQueryKey = 'orgCode';
export const PhoneBillKey = 'phoneBill';

/**
 * 딥링크(Query Param) 처리를 담당하는 훅
 * 프로필 카드나 조직도 등 특정 쿼리가 있을 때 모달/시트를 열고 URL을 정리합니다.
 */
const useDeepLinkHandler = () => {
  const router = useRouter();
  const profileCardModal = useProfileCardModal();
  const { openSheet } = useBottomSheet();
  const phoneBillDialog = usePhoneBillDialog();

  useEffect(() => {
    if (!router.isReady) return;

    const query = { ...router.query };
    let willReplace = false;

    // 1. 프로필 카드 처리
    const profileId = query[ProfileCardQueryKey];
    if (typeof profileId === 'string' && profileId) {
      profileCardModal.open(profileId, false);
      cleanUpQuery(query, [ProfileCardQueryKey]);
      willReplace = true;
    }

    // 2. 조직도 처리
    const organizationCode = query[OrganizationSheetQueryKey];
    if (typeof organizationCode === 'string' && organizationCode) {
      const viewType = (query['viewType'] as string) ?? 'list';
      const url = getOrganizationUrl(organizationCode, {
        embedded: true,
        viewType,
      });

      openSheet({
        title: '조직도',
        content: <FullViewPortHeightIframeWithLoading url={url} />,
      });

      cleanUpQuery(query, [OrganizationSheetQueryKey, 'viewType']);
      willReplace = true;
    }

    // 3. 통신비 처리
    if (PhoneBillKey in query) {
      phoneBillDialog.open();
      cleanUpQuery(query, [PhoneBillKey]);
      willReplace = true;
    }

    // 4. URL 정리 (shallow replace)
    if (willReplace) {
      router.replace({ query }, undefined, { shallow: true });
    }
  }, [router.isReady]); // 의존성 배열 최소화
};
export default useDeepLinkHandler;
